import { Image } from "@wix/wix-ui-icons-common";
import { Node_Type } from "./../ricos-types/index.js";
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from "./../editor-common/index.js";
import { INSERT_IMAGE_BUTTON } from "./data-hooks.js";
import { handleImageUpload } from "./handle-image-upload.js";
const imageAddToolbars = [
  TOOLBARS.MOBILE,
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE
];
const getAddButtons = (config, services) => {
  return [
    {
      id: Node_Type.IMAGE,
      label: INSERT_PLUGIN_BUTTONS.IMAGE,
      dataHook: INSERT_IMAGE_BUTTON,
      icon: Image,
      tooltip: "ImagePlugin_InsertButton_Tooltip",
      toolbars: imageAddToolbars,
      command: ({ publicCommands }) => {
        if (!services) {
          return false;
        }
        handleImageUpload({ services, config, publicCommands });
        return true;
      },
      menuConfig: {
        tags: "Image_plugin_search_tags"
      }
    }
  ];
};
export {
  getAddButtons,
  imageAddToolbars
};
//# sourceMappingURL=getAddButtons.js.map
